export default __webpack_public_path__ + "static/media/add-image.1b6cd588.svg";